import { useEffect, useState } from 'react';
import TripClaimsService from '../Services/TripClaimsService';
import { NO_TRIP_CLAIMS, TRIP_CLAIMS_CHANGED, canReviewTripClaims } from '../Utils/tripClaims';

// Light polling: the count only has to be roughly current; a review made
// here refreshes it at once (TRIP_CLAIMS_CHANGED), and so does coming back
// to the tab.
export const TRIP_CLAIMS_POLL_MS = 2 * 60 * 1000;

/**
 * `{ receipts, overtime, total }` waiting for review across every booking —
 * the nav badge. Asks nothing for a user who can't review claims.
 */
export default function useTripClaimsSummary(isAuthed) {
  const [counts, setCounts] = useState(NO_TRIP_CLAIMS);
  const allowed = Boolean(isAuthed) && canReviewTripClaims();

  useEffect(() => {
    if (!allowed) return undefined;
    let live = true;
    const refresh = async () => {
      try {
        const next = await TripClaimsService.summary();
        if (live) setCounts(next);
      } catch {
        // A badge is not worth an error: keep the last count.
      }
    };
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };

    refresh();
    const timer = setInterval(refresh, TRIP_CLAIMS_POLL_MS);
    window.addEventListener(TRIP_CLAIMS_CHANGED, refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener(TRIP_CLAIMS_CHANGED, refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [allowed]);

  return allowed ? counts : NO_TRIP_CLAIMS;
}
